import apiClient, { unwrap } from './client'
import type { TestMessage, TestMessageDetail } from './types'

export const testApi = {
  send(data: { from: string; to: string; subject: string; body: string }) {
    return unwrap<unknown>(apiClient.post('/test/send', data))
  },

  inbox(address: string) {
    return unwrap<TestMessage[]>(apiClient.get('/test/inbox', { params: { address } }))
  },

  message(id: number) {
    return unwrap<TestMessageDetail>(apiClient.get(`/test/message/${id}`))
  },
}
